import React from "react";
import { HelpButton } from "@/components/HelpAccess";
import { UserMenu } from "@/components/UserMenu";

/**
 * Canonical authenticated application header.
 *
 * The far-right persistent cluster is deliberately invariant across the
 * simulator flow: Sessions used -> Help -> Account. Screen-specific status
 * or actions belong in `context`, to the left of that cluster with a larger
 * visual gap so users never have to relearn where global controls live.
 */
export default function AppHeader({ context = null, sticky = false, className = "" }) {
  return (
    <header
      className={`border-b border-[color:var(--border-stone)] bg-white/95 backdrop-blur-xl ${sticky ? "sticky top-0 z-30" : ""} ${className}`}
      data-testid="app-header"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-3.5 flex items-center gap-4">
        <div className="flex min-w-0 shrink-0 items-center gap-3" data-testid="app-header-brand">
          <img
            src="/brand/globe-logo.svg"
            alt="English Job Interview Simulator"
            className="h-[63px] w-[86px] shrink-0 object-contain"
          />
          <div className="hidden sm:block whitespace-nowrap text-[10px] uppercase tracking-[0.25em] text-[color:var(--brand)] leading-tight">
            English Job Interview Simulator
          </div>
        </div>

        <div className="ml-auto flex min-w-0 items-center">
          <div
            className="mr-7 lg:mr-9 flex min-w-0 items-center justify-end gap-3"
            data-testid="app-header-context"
          >
            {context}
          </div>

          <div
            className="flex shrink-0 items-center gap-3"
            data-testid="app-header-persistent-controls"
          >
            <div
              className="shrink-0"
              data-testid="standard-session-allowance-host"
            />
            <HelpButton className="h-10 px-4 py-0 text-sm" />
            <UserMenu
              showHelp={false}
              buttonClassName="h-10 px-4 py-0 text-sm"
            />
          </div>
        </div>
      </div>
    </header>
  );
}
